import { Injectable, NgZone, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';

declare const window: any;

@Injectable({
  providedIn: 'root',
})
export class LocalStorageListenerService implements OnDestroy {
  private storageSub = new Subject<{
    key: string | null;
    value: string | null;
    oldValue: string | null;
  }>();
  storageChanges$ = this.storageSub.asObservable();

  constructor(private ngZone: NgZone) {
    window.addEventListener('storage', this.handleStorageChange);
  }

  private handleStorageChange = (event: any) => {
    this.ngZone.run(() => {
      this.storageSub.next({
        key: event.key,
        value: event.newValue,
        oldValue: event.oldValue,
      });
    });
  };

  ngOnDestroy(): void {
    window.removeEventListener('storage', this.handleStorageChange);
  }
}
